import { lazy } from '../../../shared/deployment';

export const NotificationCount = lazy(() => import('./NotificationCount'));
